var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "heart-unfilled",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-4328.694 1539.875 17.122 15.709"
      }
    },
    [
      _c("path", {
        attrs: {
          id: "Path_165",
          "data-name": "Path 165",
          d:
            "M14.413,3a5.127,5.127,0,0,0-3.852,1.789A5.127,5.127,0,0,0,6.708,3,4.663,4.663,0,0,0,2,7.708c0,3.236,2.911,5.873,7.319,9.879l1.241,1.121,1.241-1.13c4.409-4,7.319-6.635,7.319-9.871A4.663,4.663,0,0,0,14.413,3ZM10.646,16.312l-.086.086-.086-.086c-4.075-3.69-6.763-6.13-6.763-8.6a2.926,2.926,0,0,1,3-3,3.347,3.347,0,0,1,3.056,2.02h1.6a3.326,3.326,0,0,1,3.048-2.02,2.926,2.926,0,0,1,3,3C17.409,10.183,14.721,12.622,10.646,16.312Z",
          transform: "translate(-4330.694 1536.875)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-698494a6", { render: render, staticRenderFns: staticRenderFns })
  }
}